import { useEffect, useRef, useState } from "react";
import UI from "@mile-meeting/mile-ui";
import { TimeDropdownContainer, TimeDropdownItem } from "pages/meeting/booking-list/reservation-modal/index.styles";

//INFO: 회의실 예약 모달에서 예약 시간 선택으로 사용되는 컴포넌트
export const TimeInput = ({
  value,
  onChange,
  minTime = { hour: 7, minutes: 0 },
  maxTime = { hour: 22, minutes: 30 },
}: {
  value: Date;
  onChange?: (hour: number, minutes: number) => void;
  minTime?: { hour: number; minutes: number };
  maxTime?: { hour: number; minutes: number };
}) => {
  const [openTimeDropbox, setOpenTimeDropbox] = useState<boolean>(false);

  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        flex: 1,
      }}
    >
      <div style={{ position: "relative", width: "100%" }} onFocus={() => setOpenTimeDropbox(true)}>
        <UI.Input
          prefixIcon="clock"
          showPrefixIcon
          width={"100%"}
          value={`${value?.getHours().toString().padStart(2, "0")}:${value?.getMinutes().toString().padStart(2, "0")}`}
        />
        <TimeDropdown
          open={openTimeDropbox}
          setOpen={setOpenTimeDropbox}
          value={{ hour: value.getHours() ?? 7, minutes: value.getMinutes() ?? 0 }}
          onChange={(hour, minutes) => {
            onChange?.(hour, minutes);
            setOpenTimeDropbox(false);
          }}
          minTime={minTime}
          maxTime={maxTime}
        />
      </div>
    </div>
  );
};

//INFO: Time컴포넌트에서 사용되는 TimeDropdown 컴포넌트
const TimeDropdown = ({
  value,
  onChange,
  open,
  setOpen,
  minTime = { hour: 7, minutes: 0 },
  maxTime = { hour: 23, minutes: 0 },
}: {
  value: { hour: number; minutes: number };
  onChange?: (hour: number, minutes: number) => void;
  open: boolean;
  setOpen: (value: boolean) => void;
  minTime?: { hour: number; minutes: number };
  maxTime?: { hour: number; minutes: number };
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const Time = [
    { hour: 7, minutes: 0 },
    { hour: 7, minutes: 30 },
    { hour: 8, minutes: 0 },
    { hour: 8, minutes: 30 },
    { hour: 9, minutes: 0 },
    { hour: 9, minutes: 30 },
    { hour: 10, minutes: 0 },
    { hour: 10, minutes: 30 },
    { hour: 11, minutes: 0 },
    { hour: 11, minutes: 30 },
    { hour: 12, minutes: 0 },
    { hour: 12, minutes: 30 },
    { hour: 13, minutes: 0 },
    { hour: 13, minutes: 30 },
    { hour: 14, minutes: 0 },
    { hour: 14, minutes: 30 },
    { hour: 15, minutes: 0 },
    { hour: 15, minutes: 30 },
    { hour: 16, minutes: 0 },
    { hour: 16, minutes: 30 },
    { hour: 17, minutes: 0 },
    { hour: 17, minutes: 30 },
    { hour: 18, minutes: 0 },
    { hour: 18, minutes: 30 },
    { hour: 19, minutes: 0 },
    { hour: 19, minutes: 30 },
    { hour: 20, minutes: 0 },
    { hour: 20, minutes: 30 },
    { hour: 21, minutes: 0 },
    { hour: 21, minutes: 30 },
    { hour: 22, minutes: 0 },
    { hour: 22, minutes: 30 },
    { hour: 23, minutes: 0 },
  ];

  useEffect(() => {
    const handler = (event: any) => {
      if (open && ref.current && !ref.current.contains(event.target)) {
        setOpen?.(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [open]);

  const filteredTime = Time.filter((item) => {
    if (item.hour < minTime.hour || (item.hour === minTime.hour && item.minutes < minTime.minutes)) {
      return false;
    }
    if (item.hour > maxTime.hour || (item.hour === maxTime.hour && item.minutes > maxTime.minutes)) {
      return false;
    }
    return true;
  });

  useEffect(() => {
    if (open && ref.current) {
      const selectedIndex = filteredTime.findIndex(
        (time) => time.hour === value.hour && time.minutes === value.minutes
      );
      const itemHeight = 40;
      const scrollPosition = selectedIndex * itemHeight - (ref.current.clientHeight / 2 - itemHeight / 2);
      ref.current.scrollTop = scrollPosition;
    }
  }, [open, value]);

  return (
    <TimeDropdownContainer ref={ref} style={{ display: open ? "flex" : "none", width: "100%" }}>
      {Time.filter((item) => {
        if (minTime.hour === item.hour) {
          return minTime.minutes <= item.minutes;
        } else if (maxTime.hour === item.hour) {
          return maxTime.minutes >= item.minutes;
        } else {
          return minTime.hour < item.hour && maxTime.hour > item.hour;
        }
      }).map((time, index) => (
        <TimeDropdownItem key={`${time}-${index}`} onClick={() => onChange?.(time.hour, time.minutes)}>
          <UI.Typography
            type="body01 normal"
            fontStyle={value.hour === time.hour && value.minutes === time.minutes ? "bold" : "regular"}
            color="var(--alias-color-label-normal)"
          >
            {time.hour.toString().padStart(2, "0")}:{time.minutes.toString().padStart(2, "0")}
          </UI.Typography>
        </TimeDropdownItem>
      ))}
    </TimeDropdownContainer>
  );
};

export default TimeInput;
